import type { SVGProps } from "react";
export interface Loading01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Loading01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Loading01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m12.01 19.875.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006H12a1.125 1.125 0 0 1 0-2.25zm-5.493-.649a1.125 1.125 0 0 1 1.434-.463l.103.051.008.006.097.062a1.126 1.126 0 0 1-1.119 1.94l-.103-.053-.008-.005-.097-.063a1.126 1.126 0 0 1-.315-1.475m9.532-.464a1.126 1.126 0 0 1 1.022 2.002l-.009.005a1.125 1.125 0 0 1-1.125-1.949l.01-.006zm-12.41-3.245a1.125 1.125 0 0 1 1.473.315l.063.097.005.008.052.103a1.125 1.125 0 0 1-1.938 1.12l-.063-.098-.004-.008-.053-.103a1.125 1.125 0 0 1 .465-1.434m15.186.412a1.125 1.125 0 0 1 1.948 1.125l-.004.009a1.125 1.125 0 0 1-1.949-1.125zM1.875 12v-.01a1.125 1.125 0 0 1 2.25 0V12a1.125 1.125 0 0 1-2.25 0m18 0v-.01a1.125 1.125 0 0 1 2.25 0V12a1.125 1.125 0 0 1-2.25 0M3.299 6.832a1.126 1.126 0 0 1 1.887 1.222l-.006.008a1.125 1.125 0 0 1-1.95-1.124l.005-.01.063-.096Zm15.928-.315a1.125 1.125 0 0 1 1.474.315l.063.097.005.008.052.103a1.125 1.125 0 0 1-1.94 1.12l-.06-.098-.007-.008-.052-.103a1.126 1.126 0 0 1 .465-1.434m-3.71-2.878a1.125 1.125 0 0 1 1.434-.465l.103.053.009.004.096.063a1.125 1.125 0 0 1-1.119 1.938l-.102-.052-.01-.005-.096-.063a1.125 1.125 0 0 1-.315-1.473M12.01 1.875a1.125 1.125 0 0 1 0 2.25H12a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
